<template>
  <div>
    <a-form :form="form">
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Create Date">
            <a-date-picker
              placeholder="Select Date"
              :disabled="mode === 'Edit'"
              :format="getDefaultDateFormat"
              v-decorator="[
                'tgl_buat',
                {
                  rules: [{ required: true }],
                  initialValue: moment(
                    initialData.informasi.tgl_buat,
                    getDefaultDateFormat
                  ),
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="Type of Transaction">
            <a-radio-group
                    buttonStyle="solid"
                    v-decorator="['jns_transaksi',{rules: [{ required: true }],initialValue: initialData.informasi.jns_transaksi,
                },
              ]"
                    ref="site"
                    @change="handleJenisTransaksi"
                    :disabled="triggered.disabledpowo"
            >
              <a-radio-button value="1" ref="Radio1">PO</a-radio-button>
              <a-radio-button value="2" ref="Radio2">WO</a-radio-button>
            </a-radio-group>

          </a-form-item>
          <a-form-item label="No PO / WO" required >
            <v-select
                    :loading="no_po_wo && no_po_wo.length >= 0 ? false:true"
                    class="m-select"
                    :clearable="false"
                    @input="handleNoPoWo"
                    :options="no_po_wo"
                    v-model="no"
                    label="no_transaksi"
                    :disabled="jenis_transaksi!=null || triggered.disabledpowo || (this.listData && this.listData.length>0)"
            >
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner" />
              </template>
            </v-select>
          </a-form-item>
          <a-form-item label="Supplier" required>
            <!-- <a-input disabled v-decorator="['name_supplier',{rules: [{ required: false }],initialValue: initialData.informasi.name_supplier}]"
            ></a-input> -->
            <v-select
              :loading="no_po_wo && no_po_wo.length >= 0 ? false:true"
              class="m-select"
              :clearable="false"
              @input="handleSupplierlist"
              :options="supplierlist"
              v-model="supplierId"
              label="nm_supplier"
              :disabled="jenis_transaksi!=null || triggered.disabledpowo"
            >
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner" />
              </template>
            </v-select>
          </a-form-item>
          <a-form-item label="ID Supplier" hidden>
            <a-input disabled v-decorator="['id_supplier',{rules: [{ required: false }],initialValue: initialData.informasi.id_supplier}]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Address">
            <a-input disabled v-decorator="['address_supplier',{rules: [{ required: false }],initialValue: initialData.informasi.address_supplier}]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Currency">
            <a-select
              v-decorator="['currency_from', {rules: [{required: false}], initialValue: initialData.informasi.currency_from}]"
              disabled
            >
              <a-select-option
                v-for="item in getAllMataUang"
                :key="item.code"
                :value="item.code"
              >{{item.code}} - {{item.currency}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Bank Name">
                <a-input v-decorator="['name_bank',{rules: [{ required: true }],initialValue: initialData.informasi.name_bank}]"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Account Bank Number">
                <a-input v-decorator="['account_bank',{rules: [{ required: true }],initialValue: initialData.informasi.account_bank}]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="No Invoice">
                <a-input v-decorator="['no_invoice',{rules: [{ required: true }],initialValue: initialData.informasi.no_invoice}]"
                ></a-input>
              </a-form-item>
              <div style="display:none">
              <a-form-item label="No Invoice Receive">
                  <a-input v-decorator="['no_invoice_receive', { rules: [{ required: false }], initialValue: initialData.informasi.no_invoice_receive }]"
                  disabled
                  ></a-input>
                </a-form-item>
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
               <!-- <a-form-item label="No Invoice Receive">
                <a-input v-decorator="['no_invoice_receive',{rules: [{ required: false }],initialValue: initialData.informasi.no_invoice_receive}]"
                disabled
                ></a-input>
              </a-form-item>  -->
              <a-form-item label="PIB">
                <a-radio-group
                    buttonStyle="solid"
                    v-decorator="['pib',{rules: [{ required: true }],initialValue: initialData.informasi.pib,
                  },
                ]"
              >
              <a-radio-button :value="true" >Yes</a-radio-button>
              <a-radio-button :value="false" >No</a-radio-button>
            </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="No Faktur">
                <a-input v-decorator="['no_faktur',{rules: [{ required: true }],initialValue: initialData.informasi.no_faktur}]"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="No Tracking">
                <a-input v-decorator="['no_tracking',{rules: [{ required: false }],initialValue: initialData.informasi.no_tracking}]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="getScreen ? 24 : 12">
              <a-form-item label="Date of Invoice" >
                <a-date-picker v-decorator="['date_invoice',{rules: [{ required: true }],initialValue: initialData.informasi.date_invoice}]" 
                :format="getDefaultDateFormat"
                  ref="date_invoice"/>
              </a-form-item>
            </a-col>
            <a-col :span="getScreen ? 24 : 12">
              <a-form-item >
                <span slot="label">Due Date ( {{ dateCalculation }} day/s )</span
                >
                <a-date-picker v-decorator="['duedate',{rules: [{ required: true }],initialValue: initialData.informasi.duedate}]"
                :format="getDefaultDateFormat"
                  ref="duedate" @change="duedateChange"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="Description">
            <a-input v-decorator="['description',{rules: [{ required: true }],initialValue: initialData.informasi.description}]"
            ></a-input>
          </a-form-item>
          <a-row :gutter="24">
            <a-col :span="getScreen ? '24' : '8'">
              <a-form-model-item label="Use CC">
                <a-radio-group
                    ref="useCC"
                    buttonStyle="solid"
                    v-decorator="['useCC',{rules: [{ required: true }],initialValue: initialData.informasi.useCC,
                    },
                  ]"
                  @change="changeuseCC"
                  >
                  <a-radio-button :value="true" >Yes</a-radio-button>
                  <a-radio-button :value="false" >No</a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="getScreen ? '24' : '16'" v-if="$refs.useCC && $refs.useCC.value">
              <a-form-item label="User CC" required >
                <a-select
                    v-decorator="[
                      'user_cc',
                      {
                        rules: [{ required: true }],
                        initialValue: initialData.informasi.user_cc,
                      },
                    ]"
                    class="m-width-full"
                  >
                    <a-select-option
                      v-for="item in user_cc_list"
                      :key="item.id_user_cc"
                      :value="item.id_user_cc"
                      >
                      <span>{{ item.no_cc }} / {{ item.tlc }} / {{ formatCurrency("IDR", item.limit_kredit) }}</span>
                      </a-select-option
                    >
                  </a-select>

                <!-- <v-select
                  class="m-select"
                  :clearable="false"
                  :options="user_cc_list"
                  v-model="user_cc"
                  value-prop="id_user_cc"
                item-value="id_user_cc"
                >
                <template v-slot:option="option">
                  <span>{{ option.no_cc }} / {{ option.tlc }} / {{ formatCurrency("IDR", option.limit_kredit) }}</span>
                </template>
                <template
                  #selected-option-container="{ option, deselect, multiple, disabled }"
                >
                <div class="vs__selected"><span>{{ option.no_cc }} / {{ option.tlc }} / {{ formatCurrency("IDR", option.limit_kredit) }}</span></div>
                </template>
                </v-select> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="Note">
            <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="[
                'note',
                { rules: [{ required: true }],initialValue: initialData.informasi.note },
              ]"
            />
          </a-form-item>
          <a-form-item label="File Document">
            <a-upload
              :fileList="fileList"
              v-decorator="[
                'file_document',
                { rules: [{ required: true,validator: doc_validation }]},
              ]"
              :remove="handleRemove"
              :beforeUpload="beforeUpload"
            >
              <a-button>
                <a-icon type="upload" />Select File
              </a-button>
            </a-upload>
          </a-form-item>

        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
export default {
  name: "Informasi",
  props: [
    "parentListPurchasing",
    "data",
    "persetujuan",
    "projectAllsts",
    "mode",
    "id",
    "jenis_transaksi",
    "listData"
  ],
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (this.fileList==undefined || this.fileList.length==0) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    return {
      doc_validation,
      peruntukan: [],
      subPeruntukan: [],
      anggaran: [],
      no_po_wo:[],
      costCenter:[],
      modalanggaran: {
        visible: false,
        enabled: false,
        loadingButton:false,
        value: undefined,
        tree: {},
        searchValue: ""
      },
      isLoading:{
        noPoWo: false,
      },
      loadUserfor:false,
      disabledUserfor:true,
      jenisTransaksi: undefined,
      no : "",
      ppDetail : [],
      currency_to:"IDR",
      default_mata_uang:"IDR",
      default_kurs:1,
      loadPpdetail: false,
      list_mata_uang: [],
      list_mata_uang_to: [],
      loading_list_mata_uang: false,
      labeling:{
        label:undefined,
        value:undefined,
      },
      dateCalculation: 0,
      fileList: [],
      triggered: {
        disabledpowo: true,
      },
      supplierlist: [],
      supplierId: null,
      //requirementData:[],
      user_cc_list: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  watch: {
    matauang() {
      if (this.no) {
        this.getList_mata_uang();
      }
    },
    // requirementData(){
    //   if(this.requirementData){
    //     console.log(this.requirementData)
    //     //this.setinit();
    //   }
    // },
  },
  computed: {
    ...mapGetters([
      "getDefaultDateFormat",
      "getAuth",
      "getAllMataUang",
      "getScreen"
    ]),
    initialData() {
      let informasi = {};
      if (this.data === undefined || this.data.length == 0) {
        informasi = {
          tgl_buat: moment().utc(true),
          jns_transaksi: '1',
          no: null,
          name_supplier: undefined,
          id_supplier: undefined,
          currency_from: undefined,
          name_bank: undefined,
          account_bank: undefined,
          no_invoice: undefined,
          no_tracking: undefined,
          date_invoice: moment(),
          duedate: moment(),
          note: undefined,
          description: undefined,
          mata_uang: "IDR",
          rate: 1,
          fileList: [],
          pib: false,
          useCC: false,
          user_cc: null
        };
        return { informasi };
      } else {
        //this.handlePeruntukan(this.data.peruntukan);
        //this.handleSubPeruntukan(this.data.sub_peruntukan);
        //this.handleCodeAnggarn(this.data.kode_anggaran)
        //this.handleCost(this.data.cost_center)

        informasi = {
          tgl_buat: moment(this.data.tgl_buat).format(
            this.getDefaultDateFormat
          ),
          jns_transaksi: this.data.jns_transaksi,
          no: this.jenis_transaksi ? this.data.no : this.data.no_po_wo,
          name_supplier: this.data.name_supplier,
          id_supplier: this.data.id_supplier,
          address_supplier: this.data.alamat_supplier,
          currency_from: this.data.currency_from,
          name_bank: this.data.bank,
          account_bank: this.data.no_rek,
          no_faktur: this.data.no_faktur,
          no_invoice: this.data.no_invoice,
          no_tracking: this.data.no_tracking,
          date_invoice: moment(this.data.date_invoice,'YYYY-MM-DD'),
          duedate: moment(this.data.duedate,'YYYY-MM-DD'),
          description: this.data.description,
          note: this.data.note,
          currency_to: this.data.currency_to,
          rate: this.data.rate,
          fileList: this.data.fileList,
          pib: this.data.ispib=='1'?true:false,
          useCC: this.data.user_cc!=null?true:false,
          user_cc: this.data.user_cc
        };
        this.setdefaultfile(informasi.fileList);
        return { informasi };
      }
    },
  },
  created() {
  },
  methods: {
    moment,
    async handleJenisTransaksi(val){
      this.no_po_wo = [];
      this.no = "";
      this.jenisTransaksi = val.target.value;
      this.currency_to = "IDR";
      this.supplierId = "";

      // if(this.jenis_transaksi){
        this.$nextTick(function () {
          this.form.setFieldsValue({
            id_supplier: "",
            address_supplier: "",
            currency_from: "IDR",
            note: "",
            description: "",
            // value: 1,
            account_bank: "",
            name_bank: ""
          });
        });
      // }
      this.list_mata_uang = [];
      this.peruntukan = [];
      
      
      axios({
        method: "get",
        url: this.$serviceUrl + "invoice/no_transaksi",
        params: {
          jenis_transaksi: val.target.value,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then((response) => {
        this.isLoading.noPoWo = false;
        this.no_po_wo = response.data.no_transaksi;
        this.supplierlist = response.data.get_supplier;

        if(this.mode=="Create" && this.id){
          let tno = _.filter(this.no_po_wo,(el) => el.id_transaksi==this.id);
          this.no = tno[0];
        }
        // else{
        //   if(this.data){
        //     this.no = this.data.no_po_wo;
        //   }
        // }

      }).catch((err) => {
        let response = Object.assign({}, err.response);
        console.log(response);
        this.isLoading.noPoWo = false;
      });
    },
    handleCodeAnggarn(e){
      let forms = this.form.getFieldsValue();
      this.modalanggaran.value = forms.peruntukan+";"+forms.sub_peruntukan+";"+e
    },
    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle==undefined || (option.data.props.texttitle ? option.data.props.texttitle : "").toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "").toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(val){
      if (val){
        let kod = val.split(";")
        this.$nextTick(function () {
          //this.handlePeruntukan(kod[0]);
          this.form.setFieldsValue({
              peruntukan: kod[0],
          });
          //this.handleSubPeruntukan(kod[1]);
          this.form.setFieldsValue({
              sub_peruntukan: kod[1],
              kode_anggaran: kod[2]
          });
        });
      }else{
        this.$nextTick(function () {
          this.form.setFieldsValue({
              peruntukan: undefined,
              sub_peruntukan: undefined,
              kode_anggaran: undefined
          });
        });
      }
      this.modalanggaran.visible = false
    },
    showChoiceModal(){
      this.modalanggaran.visible = true
    },
    handleNoPoWo(item) {
      this.form.resetFields(["currency","value","rate"]);
      this.ppDetail = [];
      this.loadPpdetail = true;
      this.loading_list_mata_uang = true;
      this.list_mata_uang = [];

      if(!this.jenis_transaksi){
        // this.$nextTick(function () {
          this.form.setFieldsValue({ 
            id_supplier: item.id_supplier,
            // name_supplier: item.supplier,
            address_supplier: item.alamat_supplier,
            name_bank: item.bank,
            account_bank: item.no_rek,
          });
        // });
        this.supplierId = _.filter(this.supplierlist,e=>e.id_supplier==item.id_supplier)
      }

      if(this.mode=="Create"){
        axios({
          method: "get",
          url: this.$serviceUrl + "invoice/create_invoice",
          params: {
            jenis_transaksi: this.jenisTransaksi,
            id_transaksi: item.id_transaksi
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.peruntukan = response.data.no_transaksi;
            if(this.$route.meta.type_invoice=="0"){
              Event.$emit("updateList", {
                value : response.data.invoice_dtl,
                type: "delete"
              });
              Event.$emit("updatepowodtl", {value :response.data.po_wo_dtl});
            }else{
              Event.$emit("updatepowodtl", {value :response.data.pp_dtl});
            }
            this.user_cc_list = response.data.user_cc
            this.changelabeling(undefined)
            this.loadPpdetail = false;
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response);
            console.log(responses)
            this.loadPpdetail = false;
          });

        axios({
          method: "get",
          url: this.$serviceUrl + "mata_uang",
          params: this.jenis_transaksi ? {
            default_currency: item.currency,
          }: {},
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        }).then((response) => {
          this.loading_list_mata_uang = false;
            // this.form.setFieldsValue({ rate: 1 });

            this.default_mata_uang = item.currency;
            this.currency_to = item.currency;
            this.default_kurs = item.kurs;
          
          if(!this.jenis_transaksi){
            // this.list_mata_uang_to = response.data.data;
            this.list_mata_uang = response.data.data;
            this.$nextTick(function () {
            this.form.setFieldsValue({ currency_from: item.currency });
            });
            
            // Event.$emit("addendumGenAddRequirement", {
            //   id: item.id_transaksi,
            //   data_po_wo: [...this.no],
            //   pp_dtl: this.peruntukan,
            //   jenis_transaksi: this.jenisTransaksi,
            // });
          }
        }).catch((err) => {
          this.loading_list_mata_uang = false
          let responses = Object.assign({}, err.response);
          console.log(responses)
          this.isLoading.noPoWo = false;
        });
      }
    },
    // handlePeruntukan(e) {
    //   this.modalanggaran.value = undefined;
    //   this.form.resetFields(["sub_peruntukan", "kode_anggaran"]);
    //   this.anggaran = [];
    //   const filter = this.getSubPeruntukan.filter(
    //     (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
    //   );
    //   this.subPeruntukan = filter;
    // },
    handleSupplierlist(item){
      this.$nextTick(function () {
        this.form.setFieldsValue({ id_supplier: item.id_supplier });
      });
    },
    handleRef() {
      //this.confirmMessage("confirm-save");\
      if(this.no==undefined || this.no==""){
        this.displayMessageValue("error-other","No PO / WO can't be empty!");
      }else{
        this.submit()
      }
    },
    submit(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(this.moment(values.tgl_buat).format('YYYY-MM-DD')>this.moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Create date can't exceed today!");
          return;
        }

        if(parseFloat(values.value)<=0){
          this.displayMessageValue("error-other","The values must be grather than 0 !");
          return;
        }

        let id_no_po_wo = Array.isArray(this.no) ?  this.no[0].id_transaksi : this.no.id_transaksi
        let kursdata    = _.filter(this.no_po_wo,e=>e.id_transaksi==id_no_po_wo)

        const dataValues = {
          ...values,
          // currency_to: this.currency_to,
          no_po_wo: id_no_po_wo,
          fileList: this.fileList,
          mata_uang: values.currency_from,
          kurs: kursdata[0].kurs,
          // ppdtl : this.requirementData.pp_dtl,
        };
        
        Event.$emit("invData", {
          informasi: dataValues,
        });
      });
    },
    handleCurrency(item){
      if(item == this.default_mata_uang){
        this.form.setFieldsValue({ rate: 1 });
        this.changelabeling(undefined)
      }else{
        this.form.setFieldsValue({ rate: this.default_kurs });
        this.changelabeling(this.labeling.value)
      }
    },
    changelabeling(val){
      let nominal = (val!==undefined && val.target) ? val.target.value : val
      let kurs = this.currency_to == this.default_mata_uang ? 1 : parseFloat(this.default_kurs)
      if (nominal=="" || nominal==undefined){
        this.labeling.label = undefined
      }else{
        this.labeling = {
          label: "converting value : "+
            this.formatCurrency(this.default_mata_uang,parseFloat(nominal)/parseFloat(kurs)),
          value: nominal
        }
      }
    },
    // filterOption(input, option) {
    //   return (
    //     option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
    //   );
    // },
    duedateChange(val){
      this.fdateCalculation(val);
    },
    fdateCalculation(val){
      if (this.$refs.duedate){
        const today = this.moment().format(this.getDefaultDateFormat);
        const duedate = this.moment(val).format(
          this.getDefaultDateFormat
        );

        const todayFormated = this.moment(today, this.getDefaultDateFormat);
        const duedateFormated = this.moment(duedate, this.getDefaultDateFormat);
        const calc = duedateFormated.diff(todayFormated, "days");
        this.dateCalculation = calc;
      }else{
        this.dateCalculation = 0;
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
    handleRemove() {
        // const index = this.fileList.indexOf(file);
        // const newFileList = this.fileList.slice();
        // newFileList.splice(index, 1);
        // this.fileList = newFileList;
        this.fileList = [];
    },
    async getRequrementData(id,jenis_transaksi){
      Event.$emit("addendumOnLoadingPage", true);
       await this.asyncAxiosGet(
            "invoice/no_transaksi",
            this.getAuth,
            { 
              jenis_transaksi: jenis_transaksi=='PO' ? "1" : "2",
              id_transaksi: id
            }
        ).then((response) => {
            this.requirementData = response;

            this.triggered.disabledpowo = true;
            this.jenisTransaksi = (jenis_transaksi=='PO' ? "1" : "2");
            this.no_po_wo = _.filter(this.requirementData.no_transaksi,(el) => el.id_transaksi==id);
            this.no = this.no_po_wo;
            this.initialData.informasi.id_supplier = this.no_po_wo[0].id_supplier;
            this.initialData.informasi.name_supplier = this.no_po_wo[0].supplier;
            this.initialData.informasi.address_supplier = this.no_po_wo[0].alamat_supplier;
            this.initialData.informasi.currency_from = this.no_po_wo[0].currency;
            this.initialData.informasi.jns_transaksi = (jenis_transaksi=='PO' ? "1" : "2");
            this.initialData.informasi.name_bank = this.no_po_wo[0].bank;
            this.initialData.informasi.account_bank = this.no_po_wo[0].no_rek;
            this.handleNoPoWo(this.no_po_wo[0]);
            // this.list_mata_uang_to = this.requirementData.currency;
            Event.$emit("addendumOffLoadingPage", true);
        }).catch((err) => {
            Event.$emit("addendumOffLoadingPage", true);
            let responses = Object.assign({}, err.response.data);
            if (responses.message && responses.status==false){
              this.displayMessageValue("error-other", responses.message);
            }else{
              this.displayMessageValue("error", responses);
            }
        });
    },
    setinit(){
      this.triggered.disabledpowo = this.jenis_transaksi ? true : false;
        //this.jenisTransaksi = jenis_transaksi;
        //this.no_po_wo = [{
        if(this.jenis_transaksi){
          let ass= [{
            currency: this.requirementData.data_po_wo[0].currency,
            id_transaksi: this.requirementData.data_po_wo[0].id_transaksi,
            kurs:"1",
            no_transaksi: this.requirementData.data_po_wo[0].no_transaksi,
            id_supplier: this.requirementData.data_po_wo[0].id_supplier,
            supplier:this.requirementData.data_po_wo[0].supplier,
          }];
          this.no = ass;
          this.no_po_wo = ass;
        }
        this.initialData.informasi.id_supplier = this.requirementData.data_po_wo[0].id_supplier;
        this.initialData.informasi.name_supplier = this.requirementData.data_po_wo[0].supplier;
        this.initialData.informasi.currency_from = this.requirementData.data_po_wo[0].currency;
        this.initialData.informasi.jns_transaksi = this.jenis_transaksi ? this.jenis_transaksi.toLowerCase() : this.requirementData.jenis_transaksi;
        // this.list_mata_uang_to = this.requirementData.currency;
        //this.list_mata_uang = this.requirementData.currency;
    },
    setdefaultfile(file){
      this.fileList = file
    },
    changeuseCC(val){
      if(!val.target.value){
        this.$nextTick(function () {
          this.form.setFieldsValue({
            user_cc: null,
          });
        });
      }
    }
  },
  async mounted() {
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
    
    //this.no= (this.id ? this.id : undefined);
    
    if(this.data){
      //this.fileList = this.data.fileList;
      this.currency_to = this.data.currency_to;
      this.default_mata_uang = this.data.currency_from;
    }

    // harusnya check id
    if(this.mode == 'Create'){
      if (this.jenis_transaksi){
        await this.getRequrementData(this.id,this.jenis_transaksi);
        if(this.requirementData && this.requirementData.data_po_wo){
          this.setinit();
        }else{
          this.supplierlist = this.requirementData.get_supplier;
          this.supplierId = _.filter(this.supplierlist,e=>e.id_supplier==this.no_po_wo[0].id_supplier)
        }
      }else{
        let d={target:{value:(this.data.length>0 ? this.data.jns_transaksi : '1')}};
        this.jenisTransaksi = this.data.length>0 ? this.data.jns_transaksi : '1';
        this.handleJenisTransaksi(d);
        
        if(this.data){
          this.no = this.data.no_po_wo;
        }
      }
    }else{
      this.asyncAxiosGet(
        "invoice/edit",
        this.getAuth,
        { 
          id_invoice_ap_ad: this.id
        }
      ).then((response) => {
        let no_transaksi= [{
          alamat_supplier: response.invoice_hdr[0].alamat_supplier,
          bank: response.invoice_hdr[0].bank,
          currency: response.invoice_hdr[0].currency_from,
          id_supplier: response.invoice_hdr[0].id_supplier,
          id_transaksi: response.invoice_hdr[0].no_po_wo,
          kode_project:  response.no_transaksi[0].kode_project,
          kurs: response.no_transaksi[0].kurs,
          no_pp: response.no_transaksi[0].no_pp,
          no_rek: response.invoice_hdr[0].no_rek,
          no_transaksi: response.no_transaksi[0].no_transaksi,
          supplier: response.invoice_hdr[0].name_supplier ? response.invoice_hdr[0].name_supplier : response.invoice_hdr[0].supplier
        }];
        this.requirementData={no_transaksi:no_transaksi};
        this.supplierlist = response.get_supplier;
        let typefile = this.fileTypeFromUrl(response.invoice_hdr[0].document_name);
        let file = this.dataURLtoFile(typefile+response.invoice_hdr[0].document_file, response.invoice_hdr[0].document_name);
        file.uid= 'vc-upload-1-1';
        file.status= 'done';
        file.url= this.$serviceUrl+response.invoice_hdr[0].document_path;
        let hdr = response.invoice_hdr[0];
        hdr['fileList']=[];
        hdr.fileList.push(file);
        let tempdtl = response.invoice_dtl;
        if(this.$route.meta.type_invoice=="1"){
          
          for (let ippdtl = 0; ippdtl < tempdtl.length; ippdtl++) {
            tempdtl[ippdtl]['po_wo_id'] = tempdtl[ippdtl].pp_dtl_id;
            tempdtl[ippdtl]['pib'] = tempdtl[ippdtl].pib && tempdtl[ippdtl].pib=='1' ? true : false;
          }
        }

        Event.$emit("invDataEdit", {
          informasi: hdr,
          dtlForEdit: tempdtl,
        });
            
        this.triggered.disabledpowo = true;
        this.jenisTransaksi = (this.type=='PO' ? "1" : "2");
        this.no_po_wo = response.no_transaksi;
        this.no = response.no_transaksi;
        this.initialData.informasi.id_supplier = this.requirementData.no_transaksi[0].supplier;
        this.initialData.informasi.name_supplier = this.requirementData.no_transaksi[0].nama_supplier;
        this.initialData.informasi.address_supplier = this.requirementData.no_transaksi[0].alamat_supplier;
        this.initialData.informasi.currency_from = this.requirementData.no_transaksi[0].currency;
        this.initialData.informasi.jns_transaksi = (this.type=='PO' ? "1" : "2");
        this.initialData.informasi.name_bank = this.requirementData.no_transaksi[0].bank_name;
        this.initialData.informasi.account_bank = this.requirementData.no_transaksi[0].account_bank_number;
        this.supplierId = _.filter(this.supplierlist,e=>e.id_supplier==this.requirementData.no_transaksi[0].id_supplier)
        this.user_cc_list = response.user_cc
        this.handleNoPoWo(this.requirementData.no_transaksi[0]);
        
        if(this.$route.meta.type_invoice=="0"){
          Event.$emit("updatepowodtl", {value :response.po_wo_dtl});
        }else{
          Event.$emit("updatepowodtl", {value :response.pp_dtl});
        }
      }).catch((err) => {
          let responses = Object.assign({}, err);
          console.log(responses)
          if (responses.message && responses.status==false){
            this.displayMessageValue("error-other", responses.message);
          }else{
            this.displayMessageValue("error", responses);
          }
      });
    }
    if(this.parentListPurchasing && this.parentListPurchasing.length>0){
      this.triggered.disabledpowo = true;
    }else{
      this.triggered.disabledpowo = this.mode=='Create' && !this.jenis_transaksi ? false : true;
    }
    this.list_mata_uang = this.getAllMataUang;
    this.list_mata_uang_to = this.getAllMataUang;
  },
  beforeDestroy() {
  },

};
</script>

<style lang="less">
.ant-select-selection-selected-value{
  width: 100%
}
</style>
